import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { User, Mail, Phone, Pencil, Users } from "lucide-react";

interface ClientInfoCardProps {
  booking: any;
  clientFormData: {
    fullName: string;
    email: string;
    phone: string;
  };
  onEdit: () => void;
  canEdit: boolean;
  showParticipantEdit?: boolean;
  onEditParticipantCount?: () => void;
  hideParticipants?: boolean;
}

export function ClientInfoCard({
  booking,
  clientFormData,
  onEdit,
  canEdit,
  showParticipantEdit = false,
  onEditParticipantCount,
  hideParticipants = false,
}: ClientInfoCardProps) {
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle className="text-lg">Client information</CardTitle>
        {canEdit && (
          <Button variant="ghost" size="sm" onClick={onEdit}>
            <Pencil className="h-4 w-4" />
          </Button>
        )}
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center gap-3">
          <User className="h-5 w-5 text-gray-400" />
          <div>
            <Label className="text-muted-foreground">Full name</Label>
            <p className="font-medium">
              {clientFormData.fullName || "Not provided"}
            </p>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <Mail className="h-5 w-5 text-gray-400" />
          <div>
            <Label className="text-muted-foreground">Email</Label>
            <p className="font-medium">
              {clientFormData.email || "Not provided"}
            </p>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <Phone className="h-5 w-5 text-gray-400" />
          <div>
            <Label className="text-muted-foreground">Phone</Label>
            <p className="font-medium">
              {clientFormData.phone || "Not provided"}
            </p>
          </div>
        </div>

        {!hideParticipants && booking.participant_count && (
          <div className="flex items-center gap-3">
            <Users className="h-5 w-5 text-gray-400" />
            <div>
              <Label className="text-muted-foreground">
                Number of participants
              </Label>
              <p className="font-medium">{booking.participant_count}</p>
            </div>
          </div>
        )}

        {!hideParticipants && showParticipantEdit && (
          <div className="flex items-center gap-3">
            <Users className="h-5 w-5 text-gray-400" />
            <div className="flex-1">
              <Label className="text-muted-foreground">
                Actually showed up
              </Label>
              <div className="flex items-center gap-2">
                <p className="font-medium">
                  {booking.showed_up_participants ??
                    booking.participant_count ??
                    "-"}
                </p>
                {onEditParticipantCount && (
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={onEditParticipantCount}
                    className="h-6 px-2"
                  >
                    <Pencil className="h-3 w-3" />
                  </Button>
                )}
              </div>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
